import './HubMarker.scss';

export const HubMarker = document.createElement('div');
HubMarker.className = 'marker';
